import { useMemo } from "react";

import { FormProps } from "../../components/form-item/framework/react/FormProvider";
import { useFormDialog } from "../../components/form-item/client/components/FormDialog";
import { PageFormItem, GroupFormItem, InfoFormItem, TextAreaFormItem } from "../../components/form-item/client/components";

export enum AskForHelpAsGuestFormIds {
    TextAreaName = "TextAreaName",
    TextAreaEmail = "TextAreaEmail",
    TextAreaPhoneNumber = "TextAreaPhoneNumber",
    TextAreaMessage = "TextAreaMessage",
}

export type AskForHelpAsGuestForm =
    GroupFormItem<[
        InteractionPage,
        ConfirmPage
    ]>

type InteractionPage =
    PageFormItem<GroupFormItem<[
        InfoFormItem,
        TextAreaFormItem,
        TextAreaFormItem,
        TextAreaFormItem,
        TextAreaFormItem,
    ]>>

type ConfirmPage = PageFormItem<InfoFormItem>

export const useAskForHelpAsGuestDialog = (onConfirm: FormProps<AskForHelpAsGuestForm>["onSubmit"]) => {

    const form: AskForHelpAsGuestForm = useMemo(() => {
        const interactionPage: InteractionPage = {
            type: "page",
            title: "Bed om hjælp",
            item: {
                type: "group",
                render: "all at once",
                items: [
                    {
                        type: "info",
                        render: "default",
                        text: `
                            Har du brug for hjælp, kan du altid komme i kontakt med os via denne formular. Vi svarer dig hurtigst muligt.
                        `,
                    },
                    {
                        id: AskForHelpAsGuestFormIds.TextAreaName,
                        type: "text-area",
                        render: "text-field",
                        label: "Navn",
                        placeholder: null,
                        value: "",
                        dirty: false,
                        validation: "full name",
                    },
                    {
                        id: AskForHelpAsGuestFormIds.TextAreaEmail,
                        type: "text-area",
                        render: "text-field",
                        label: "Email",
                        placeholder: null,
                        value: "",
                        dirty: false,
                        validation: "email",
                    },
                    {
                        id: AskForHelpAsGuestFormIds.TextAreaPhoneNumber,
                        type: "text-area",
                        render: "text-field",
                        label: "Telefon",
                        placeholder: null,
                        value: "",
                        dirty: false,
                        validation: "phone",
                    },
                    {
                        id: AskForHelpAsGuestFormIds.TextAreaMessage,
                        type: "text-area",
                        render: "text-area",
                        label: "Hvad har du brug for hjælp til?",
                        placeholder: "Fortæl os hvad vi kan hjælpe dig med",
                        value: "",
                        dirty: false,
                        validation: "mandatory",
                        hint: "Vær gerne så tydelig som muligt",
                    },
                ],
            },
        }
    
        const confirmPage: PageFormItem<InfoFormItem> = {
            type: "page",
            title: "Bed om hjælp",
            item: {
                type: "info",
                render: "default",
                text: `
                    Hvis du har bedt om hjælp for at kunne udføre dine opgaver, og du ikke hører fra os med det samme, skal du ikke bekymre dig.<br />
                    <br />
                    Vi glemmer dig ikke og vil vende tilbage til dig hurtigst muligt, senest inden for 2 arbejdsdage.
                `,
            },
        };

        return {
            type: "group",
            render: "all at once",
            items: [interactionPage, confirmPage],
        };
    }, []);

    return useFormDialog(form, onConfirm);
};
